/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import BaseBigHugeCircuit from '../../implementation-common/big-huge-circuit';
import * as ReverseImplementation from './reverse-implementation';

export default class InductorLowPassBigHugeCircuit extends BaseBigHugeCircuit {
  @computed('c1', 'r1', 'r3', 'r4', 'l1') get circuitStageValues() {
    var c1 = this.c1;
    var r1 = this.r1;
    var r3 = this.r3;
    var r4 = this.r4;
    var l1 = this.l1;
    var result = ReverseImplementation.computeFromComponentValues(c1, r1, r3, r4, l1);
    return result;
  }
}
